/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const InstructorIcon = /*#__PURE__*/ createSvgIcon(
  'InstructorIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10.5 4.004c0 .414-.147.767-.44 1.059A1.45 1.45 0 019 5.5a1.537 1.537 0 01-.792-.23c-.32.07-.604.213-.854.428s-.424.483-.52.802h9.271c.236 0 .426.087.572.26a.717.717 0 01.156.615l-.729 4a.682.682 0 01-.246.45.733.733 0 01-.483.175h-2.833v-1.5h2.208c.07-.417.146-.833.23-1.25.082-.417.159-.833.228-1.25H4.792c.069.417.145.833.229 1.25.083.417.16.833.229 1.25h2.208V12h-2.84a.726.726 0 01-.475-.175.68.68 0 01-.247-.45l-.73-4a.711.711 0 01.16-.615.715.715 0 01.57-.26h1.396a3.166 3.166 0 01.74-1.604 3.27 3.27 0 011.468-.98c.028-.402.184-.739.469-1.01.284-.27.625-.406 1.022-.406.423 0 .78.147 1.071.442.292.294.438.649.438 1.062zM8.312 15.5h3.375l.605-5H7.708l.604 5zm4.013 1.5h-4.65a.74.74 0 01-.758-.667l-.688-5.645c-.056-.448.07-.841.376-1.18C6.911 9.17 7.286 9 7.73 9h4.542c.443 0 .817.17 1.124.508.306.339.431.732.376 1.18l-.688 5.645a.741.741 0 01-.758.667z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default InstructorIcon;
